import { AreaChart, Area, YAxis, XAxis, CartesianGrid } from 'recharts';

export const formatTemperatureTick = (tick: number) =>
    `${tick}°C`
;

// Note: The temperature data must be clipped from [ 0C, 100C ] in order for the gradient
// to work correctly... because the 100% number starts from the highest data point and
// the 0% corresponds to the lowest data point. So this also means that the data set must
// have an artificial 0 and 100 somewhere off the chart (i.e. beyond the visible X axis).
export const TemperatureChart = ({ fromDate, toDate, ticks, data, tickFormatter }: any) =>
    <AreaChart width={ 1024 } height={ 180 } data={ data }>
        <defs>
            <linearGradient id="lg-temp" x1="0" y1="1" x2="0" y2="0">
                <stop offset="30%" stopColor="#0f0" stopOpacity={ .1 }/>
                <stop offset="45%" stopColor="#0f0" stopOpacity={ .5 }/>
                <stop offset="55%" stopColor="#0f0" stopOpacity={ .5 }/>
                <stop offset="65%" stopColor="#ee0" stopOpacity={ .5 }/>
                <stop offset="80%" stopColor="#ee0" stopOpacity={ .8 }/>
                <stop offset="100%" stopColor="#f00" stopOpacity={ 1 }/>
            </linearGradient>
        </defs>
        <Area type="monotone" dataKey="value" fill="url(#lg-temp)" isAnimationActive={ false } activeDot={ { stroke: '#fff', fill: '#8884d8', strokeWidth: 1 } }/>
        <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
        <XAxis type="number" domain={ [ fromDate, toDate ] } dataKey="name" ticks={ ticks } tickFormatter={ tickFormatter } allowDataOverflow={ true } /* TODO: fontSize=".8em" */ />
        <YAxis type="number" domain={ [ 30, 100 ] } ticks={ [ 45, 55, 65, 85, 100 ] } tickFormatter={ formatTemperatureTick } allowDataOverflow={ true }/>
    </AreaChart>
;
